var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M480,0H32C14.312,0,0,14.312,0,32v448c0,17.688,14.312,32,32,32h448c17.688,0,32-14.312,32-32V32  C512,14.312,497.688,0,480,0z M192,256c0,0,5.062-64,64-64c58.938,0,64,64,64,64s1.844,64-64,64C190.156,320,192,256,192,256z   M448,448H64V224h64h4.53c-2.655,10.281-4.53,20.875-4.53,32c0,70.688,57.312,128,128,128c70.688,0,128-57.312,128-128  c0-11.125-1.875-21.719-4.531-32H384h64V448z M448,160h-96V64h96V160z"}));
}

Instagram.defaultProps = {"enableBackground":"new 0 0 512 512","height":"512px","id":"Layer_1","version":"1.1","viewBox":"0 0 512 512","width":"512px","xmlSpace":"preserve"};

module.exports = Instagram;

Instagram.default = Instagram;
